import { render, staticRenderFns } from "./transportCompany.vue?vue&type=template&id=57824734"
import script from "./transportCompany.vue?vue&type=script&lang=js"
export * from "./transportCompany.vue?vue&type=script&lang=js"
import style0 from "./transportCompany.vue?vue&type=style&index=0&id=57824734&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57824734')) {
      api.createRecord('57824734', component.options)
    } else {
      api.reload('57824734', component.options)
    }
    module.hot.accept("./transportCompany.vue?vue&type=template&id=57824734", function () {
      api.rerender('57824734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/transportCompany.vue"
export default component.exports